import Debug from "../../../common-deprecated/Debug";
import { POSTAL_CHANNEL_T1_HASH, POSTAL_TOPIC_HASH_ADD } from "../../../common-deprecated/constants";
import type { AEMFormTypes } from "../../../common-deprecated/types/CommonTypes";
import { findPathInObject } from "../../../common-deprecated/utils";
import { postalPublish } from "../../../common-deprecated/utils/postalUtils";
import type { CommonCtaButtonType } from "../types/CtaButtonType";
import type { SavedConfigType } from "../types/SaveTypes";

export const replaceUrlPlaceholders = (
    tyCode: string,
    modelInfo: {
        id: string;
        internalCode: string;
        name: string;
    },
    url?: string,
): string => {
    return url
        ? url
              .replace("{configCode}", tyCode)
              .replace("{tyCode}", tyCode)
              .replace("{modelId}", modelInfo.id)
              .replace("{modelCode}", modelInfo.internalCode)
              .replace("{modelName}", modelInfo.name)
        : "";
};

export const handleUrl = (url: string, target: string): void => {
    if (target === "_blank") {
        window.open(url);
        return;
    }

    const isHashLink = !!url?.match(/^(\/?#)/gi);
    if (target === "_self" && !isHashLink) {
        window.location.assign(url);
        return;
    }

    postalPublish({
        channel: POSTAL_CHANNEL_T1_HASH,
        topic: POSTAL_TOPIC_HASH_ADD,
        data: isHashLink ? url : `/iframe/${encodeURIComponent(url)}`,
    });
};

export const handleCustomCta = <T extends { jsfunction?: string }>(
    ctaConfig: T,
    href: string,
    tyCode: string,
    target: string,
): void => {
    if (ctaConfig.jsfunction) {
        try {
            const customFunction =
                findPathInObject(ctaConfig.jsfunction, window) || window[ctaConfig.jsfunction as any];
            if (customFunction) customFunction(tyCode);
            else Debug.error(`Could not execute custom CTA function ${ctaConfig.jsfunction}`);
        } catch (error) {
            Debug.error("Could not execute custom CTA function:", error);
        }
    } else if (href) {
        handleUrl(href, target);
    } else {
        Debug.error("No custom CTA url defined");
    }
};

export const getTyCodeFromSaveData = (saveData: SavedConfigType | null): string =>
    saveData?.Personal?.Code || saveData?.ConfigurationCode || "";

export const getCtaArguments = (
    saveData: SavedConfigType | null,
    modelInfo: {
        id: string;
        internalCode: string;
        name: string;
    },
    ctaConfig: CommonCtaButtonType,
): {
    tyCode: string;
    target: "_blank" | "overlayer" | "_self";
    href: string;
} => {
    const tyCode = getTyCodeFromSaveData(saveData);
    return {
        tyCode,
        target: ctaConfig.target || "_self",
        href: replaceUrlPlaceholders(tyCode, modelInfo, ctaConfig.url),
    };
};

export const getAemFormsUrl = (type: AEMFormTypes, fallback?: string, tyCode?: string): string | null => {
    let url = window.dxp?.settings?.forms?.[type] || fallback;
    if (!url) return null;

    // on author, the dxp settings contain paths like /content/toyota/forms/xxx without any query params
    if (url.match(/^\/content\/[^?]+$/)) {
        url += ".html";
    }
    if (tyCode && !url.includes("tyCode=")) {
        url += `${url.includes("?") ? "&" : "?"}tyCode=${tyCode}`;
    }
    return url;
};
